module.exports = __webpack_public_path__ + "media/images/top/img_pickup_tomita-f0d059551f5b55028f614101158d5eb3.webp";